import { render, staticRenderFns } from "./Anniversary.vue?vue&type=template&id=450a4ee3"
import script from "./Anniversary.vue?vue&type=script&lang=js"
export * from "./Anniversary.vue?vue&type=script&lang=js"
import style0 from "./Anniversary.vue?vue&type=style&index=0&id=450a4ee3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports